import { packedYaw } from "./angles.js";
import type { Input, PackedInput } from "./types.js";
export function pack(input: Input): PackedInput {
  return [
    1,
    input.f,
    input.s,
    packedYaw(input.yaw),
    Math.round(input.pitch * 1e5) / 1e5,
    (input.jump ? 1 : 0) | (input.duck ? 2 : 0) | (input.reset ? 4 : 0),
  ];
}
export function unpack(p: PackedInput): Input {
  return {
    f: p[1],
    s: p[2],
    yaw: p[3],
    pitch: p[4],
    jump: !!(p[5] & 1),
    duck: !!(p[5] & 2),
    reset: !!(p[5] & 4),
  };
}
export function record(list: PackedInput[], input: Input): Input {
  const p = pack(input),
    last = list.at(-1);
  if (last && last.slice(1).every((v, i) => v === p[i + 1]) && last[0] < 65535)
    last[0]++;
  else list.push(p);
  return unpack(p);
}
export function* frames(inputs: PackedInput[]) {
  for (const p of inputs) for (let i = 0; i < p[0]; i++) yield unpack(p);
}
export function formatTime(seconds: number | null | undefined) {
  if (seconds == null) return "—";
  return (
    Math.floor(seconds / 60)
      .toString()
      .padStart(2, "0") +
    ":" +
    (seconds % 60).toFixed(3).padStart(6, "0")
  );
}
